<template>
  <div class="preview" style="overflow-x: scroll">
    <loading-cube v-if="loading"/>
    <div v-if="!loading" class="preview-container">
      <div class="dates">
        <h1><i class="fas fa-calendar-alt"></i>Submission Totals for Period: {{ start_date }} - {{ end_date }}</h1>
        <p>
          The following is a preview per worker for all payments entered. Any workers highlighted in
          green have had their payments submitted for this pay
          period.
        </p>
        <p>Please do not use this as an invoice.</p>
        <button class="btn orcaBtn" style="margin-top: 1em;" @click="reloadRoute">
          <span>Refresh totals</span>
        </button>
      </div>

      <table v-if="cells && cells.length > 0" class="table">
        <thead>
        <tr>
          <th>Full Name</th>
          <th v-for="(timesheetAuthorisation, index) in data" :style="zIndexReverse(data.length, index)"
              class="rotate">
            <div class="capsule">
              <span>{{ timesheetAuthorisation.location }}</span>
            </div>
          </th>
          <th class="text-right">Pre Tax Addition</th>
          <th class="text-right">Post Tax Addition</th>
          <th class="text-right">Pre Tax Deduction</th>
          <th class="text-right">Post Tax Deduction</th>
          <th class="text-right">Total</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(cell,cIndex) in cells" :class="{ 'submit': cell.submit }">
          <th><strong>{{ cell.name }}</strong></th>
          <td v-for="timesheetAuthorisation in data" class="text-right">
            {{ cell['locations'][timesheetAuthorisation.location] | currency }}
          </td>
          <td class="text-right">
            <button v-if="cell.add_ded.pre_tax_additions > 0" class="btn explain_button"
                @click="()=>showModal(cell.ref + 'pre_tax_additions')">
              <b-icon icon="info"/>
            </button>
            {{ cell.add_ded.pre_tax_additions | currency }}
            <simple_modal :ref="cell.ref + 'pre_tax_additions'" :data="{...cell.add_ded_explained.pre_tax_additions}"/>
          </td>
          <td class="text-right">
            <button v-if="cell.add_ded.post_tax_additions > 0" class="btn explain_button"
                @click="()=>showModal(cell.ref + 'post_tax_additions')">
              <b-icon icon="info"/>
            </button>
            {{ cell.add_ded.post_tax_additions| currency }}
            <simple_modal :ref="cell.ref + 'post_tax_additions'"
                :data="{...cell.add_ded_explained.post_tax_additions}"/>
          </td>
          <td class="text-right">
            <button v-if="cell.add_ded.pre_tax_deductions > 0" class="btn explain_button"
                @click="()=>showModal(cell.ref + 'pre_tax_deductions')">
              <b-icon icon="info"/>
            </button>
            {{ cell.add_ded.pre_tax_deductions | currency }}
            <simple_modal :ref="cell.ref + 'pre_tax_deductions'"
                :data="{...cell.add_ded_explained.pre_tax_deductions}"/>
          </td>
          <td class="text-right">
            <button v-if="cell.add_ded.post_tax_deductions > 0" class="btn explain_button"
                @click="()=>showModal(cell.ref + 'post_tax_deductions')">
              <b-icon icon="info"/>
            </button>
            {{ cell.add_ded.post_tax_deductions | currency }}
            <simple_modal :ref="cell.ref + 'post_tax_deductions'"
                :data="{...cell.add_ded_explained.post_tax_deductions}"/>
          </td>
          <td class="text-right">{{ cell.invoiceTotal | currency }}</td>
          <!--                        <td>{{JSON.stringify(cell)}}</td>-->
        </tr>
        </tbody>
        <tfoot v-if="this.cellTotals">
        <tr>
          <th></th>
          <td v-for="(timesheetAuthorisation, index) in data" class="text-right">
            {{ cellTotals['locations'][timesheetAuthorisation.location] | currency }}
          </td>

          <td class="text-right">{{ cellTotals.pre_add_total | currency }}</td>
          <td class="text-right">{{ cellTotals.post_add_total | currency }}</td>
          <td class="text-right">{{ cellTotals.pre_ded_total | currency }}</td>
          <td class="text-right">{{ cellTotals.post_ded_total | currency }}</td>
          <td class="text-right">{{ cellTotals.invoiceTotal | currency }}</td>
        </tr>
        </tfoot>
      </table>
      <div v-else>No Rows found...</div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.explain_button {
  margin-right: 1em;
  background-color: lightgreen;
  color: white !important;
  padding: 2px !important;
  border-radius: 200px;
}

.dates {
  border: 1px solid #eee;
  padding: 20px;
  margin-bottom: 10px;

  i {
    $size: 50px;
    color: white;
    width: $size;
    height: $size;
    text-align: center;
    line-height: $size;
    vertical-align: middle;
    background-color: $bc_1;
    border-radius: $border-radius;
    margin-right: 10px;
  }

  p {
    font-size: 18px;
  }
}

table.table {
  width: 100%;
  margin-top: 40px;
  background-color: white !important;
  border-collapse: separate;
  border-spacing: 0;

  thead {
    background-color: transparent !important;

    th {
      box-shadow: none;
      position: sticky;
      top: 0;
      z-index: 2;
      background-color: white;
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);

      &:first-child {
        z-index: 998;
        left: 0;
      }

    }

    th.rotate {
      .capsule {
        width: 50px;
        position: relative;
        background: transparent;

        span {
          transform: translate(-25px, -90px) rotate(-45deg);
          position: absolute;
          width: 200px;
        }
      }
    }
  }

  tbody {
    tr {
      th {
        position: sticky;
        left: 0;
        background: white;
        z-index: 1;

        &:first-child {
          position: sticky;
          z-index: 2;
          left: 0;
          border-right: 1px solid rgba(0, 0, 0, 0.2);
        }
      }

      &:nth-child(odd) {
        th, td {
          background-color: #f0f0f0;
        }
      }

      th, td {
        background-color: #f8f8f8;

        padding: 15px;
        vertical-align: middle;

        .invoice-summary {
          $size: 40px;
          width: $size;
          height: $size;
          border-radius: 100px;
          display: inline-block;
          background-color: rgba(0, 0, 0, 0.1);
          cursor: pointer;
          text-align: center;
          line-height: $size;

          &:hover {
            background-color: rgba(255, 255, 255, 0.8);
          }
        }
      }

      &:hover {
        th, td {
          background-color: lighten($bc_1, 25%);
        }
      }

      &.ready {
        th, td {
          background-color: #a9daa9;
        }
      }

      &.not-ready {
        th, td {
          background-color: #f5f83a;
        }
      }

      &.worker-ready {
        th, td {
          background-color: #4b83d3;
        }
      }
    }
  }

  tfoot {
    th {
      box-shadow: none;
      position: sticky;
      z-index: 2;
      background: white;

      &:first-child {
        z-index: 100;
        left: 0;
      }

    }
  }
}


.preview {
  padding: 20px;

  .preview-container {
    overflow-x: scroll;

    table {

      thead {
        th {
          height: 230px;

          &:first-child {
            z-index: 998;
          }

          &.rotate {
            span {
              transform: translate(55px, -140px) rotate(-45deg);
              width: 250px;
            }
          }
        }
      }

      tbody {
        tr.submit {
          th, td {
            background-color: #bfddbf;
          }
        }
      }

      tfoot {
        th, td {
          min-width: 160px;
          padding: 20px;
        }
      }
    }
  }
}
</style>
<script>
import Vue from 'vue';
import {BootstrapVueIcons} from 'bootstrap-vue'
import loadingCube from "loaders/record_loader.vue";
import simple_modal from "pages/sunset/timesheets/components/modals/simple_modal.vue";

Vue.use(BootstrapVueIcons);

export default {
  name: "timesheet_preview_all",
  components: {
    loadingCube,
    simple_modal
  },
  props: {
    company_id: {required: true},
    start_date: {required: true},
    end_date: {required: true}
  },
  data() {
    return {
      back: { name: 'a_timesheet_r2_select_sites', params: { company_id: this.company_id, start_date: this.start_date, end_date: this.end_date} },
      loading: false,
      cells: null,
      cellTotals: null,
      redraw: 0,
      data: false,
      workers: [],
      week: [],
      preview: true,
      loadingData: false, //old but left in for now
      ms_opts: {},
      timesheetPreTaxAdditionsOptions: [],
      timesheetPostTaxAdditionsOptions: [],
      timesheetPreTaxDeductionsOptions: [],
      timesheetPostTaxDeductionsOptions: []
    }
  },
  async beforeMount() {
    this.loading = true;
    this.submissionDate = {
      end_date: this.end_date,
      start_date: this.start_date
    };
    await this.updateOpts();
    await this.loadData();
    await this.doSummaries();
    this.loading = false;
  },
  methods: {
    reloadRoute() {
      this.$router.go();
    },
    async updateOpts() {
      this.hardCodeTypes();
      this.timesheetPreTaxAdditionsOptions = this.ms_opts.pre_add;
      this.timesheetPostTaxAdditionsOptions = this.ms_opts.post_add;
      this.timesheetPreTaxDeductionsOptions = this.ms_opts.pre_ded;
      this.timesheetPostTaxDeductionsOptions = this.ms_opts.post_ded;
    },
    hardCodeTypes() {
      this.ms_opts.pre_add = [
        {
          "id": 107,
          "crm_attribute_master_type_id": 29,
          "value": "Bonus"
        },
        {
          "id": 112,
          "crm_attribute_master_type_id": 29,
          "value": "Fee"
        },
        {
          "id": 162,
          "crm_attribute_master_type_id": 29,
          "value": "Fuel\/Mileage"
        },
        {
          "id": 111,
          "crm_attribute_master_type_id": 29,
          "value": "Loan"
        },
        {
          "id": 170,
          "crm_attribute_master_type_id": 29,
          "value": "Miscellaneous"
        },
        {
          "id": 108,
          "crm_attribute_master_type_id": 29,
          "value": "Overtime (Bonus)"
        },
        {
          "id": 110,
          "crm_attribute_master_type_id": 29,
          "value": "Price Work"
        }
      ];
      this.ms_opts.post_add = [
        {
          "id": 114,
          "crm_attribute_master_type_id": 30,
          "value": "Clothing"
        },
        {
          "id": 116,
          "crm_attribute_master_type_id": 30,
          "value": "Fuel \/ Mileage"
        },
        {
          "id": 171,
          "crm_attribute_master_type_id": 30,
          "value": "Miscellaneous"
        },
        {
          "id": 136,
          "crm_attribute_master_type_id": 30,
          "value": "Parking"
        },
        {
          "id": 157,
          "crm_attribute_master_type_id": 30,
          "value": "Subsistence"
        },
        {
          "id": 113,
          "crm_attribute_master_type_id": 30,
          "value": "Tools\/Materials"
        }
      ];
      this.ms_opts.pre_ded = [
        {
          "id": 119,
          "crm_attribute_master_type_id": 31,
          "value": "Loan"
        },
        {
          "id": 172,
          "crm_attribute_master_type_id": 31,
          "value": "Miscellaneous"
        },
        {
          "id": 118,
          "crm_attribute_master_type_id": 31,
          "value": "Over Payment"
        },
        {
          "id": 120,
          "crm_attribute_master_type_id": 31,
          "value": "Van Hire"
        }
      ];
      this.ms_opts.post_ded = [
        {
          "id": 123,
          "crm_attribute_master_type_id": 32,
          "value": "Clothing"
        },
        {
          "id": 128,
          "crm_attribute_master_type_id": 32,
          "value": "Fines"
        },
        {
          "id": 125,
          "crm_attribute_master_type_id": 32,
          "value": "Loan"
        },
        {
          "id": 173,
          "crm_attribute_master_type_id": 32,
          "value": "Miscellaneous"
        },
        {
          "id": 129,
          "crm_attribute_master_type_id": 32,
          "value": "Parking"
        },
        {
          "id": 122,
          "crm_attribute_master_type_id": 32,
          "value": "Tools\/Materials"
        },
        {
          "id": 121,
          "crm_attribute_master_type_id": 32,
          "value": "Training"
        },
        {
          "id": 124,
          "crm_attribute_master_type_id": 32,
          "value": "Van Hire"
        }
      ];
    },
    async doSummaries() {
      let cells = [];
      let current = null;
      this.workers.forEach((worker, wIndex) => {
        current = {
          ref: `cell${wIndex}`,
          name: this.getPreviewWorkerFullName(worker),
          submit: this.isPreviewWorkerSubmitted(worker),
        };

        current.locations = {};
        this.data.forEach((authorisation, aIndex) => {
          current.locations[authorisation.location] = this.getPreviewWorkerTotalBeforeAdditionsAndDeductions(worker, authorisation);
        });

        current.add_ded = {
          'pre_tax_additions': this.getPreviewWorkerPreTaxAddition(worker),
          'post_tax_additions': this.getPreviewWorkerPostTaxAddition(worker),
          'pre_tax_deductions': this.getPreviewWorkerPreTaxDeduction(worker),
          'post_tax_deductions': this.getPreviewWorkerPostTaxDeduction(worker),
        };

        current.add_ded_explained = {
          'pre_tax_additions': this.explainWorkerPreTaxAddition(worker),
          'post_tax_additions': this.explainWorkerPostTaxAddition(worker),
          'pre_tax_deductions': this.explainWorkerPreTaxDeduction(worker),
          'post_tax_deductions': this.explainWorkerPostTaxDeduction(worker),
        };

        current.invoiceTotal = this.getPreviewWorkerInvoiceTotal(worker);

        cells.push({...current});
      });

      let cellTotals = {};
      this.cells = [...cells];

      cellTotals['locations'] = {};

      this.data.forEach((authorisation, aIndex) => {
        cellTotals['locations'][authorisation.location] = this.getPreviewSumOfTotalBeforeAdditionsAndDeductions(authorisation);
      });

      cellTotals.pre_add_total = this.getPreviewSumOfPreTaxAddition();
      cellTotals.post_add_total = this.getPreviewSumOfPostTaxAddition();
      cellTotals.pre_ded_total = this.getPreviewSumOfPreTaxDeduction();
      cellTotals.post_ded_total = this.getPreviewSumOfPostTaxDeduction();

      cellTotals.invoiceTotal = this.getPreviewSumOfInvoiceTotal();

      this.cellTotals = {...cellTotals};

    },
    async showPreview() {
      this.preview = !this.preview;
    },
    async loadData() {
      this.loadingData = true;
      await axios.get(this.crmApiPath + 'timesheet_authorisation/orders/where/contact/' + this.$store.state.auth.me.contact_id, {
        params: {
          ts_submission_date: this.submissionDate.end_date,
          page_length: 9999,
          order_workers_by_direction: 'asc',
          order_workers_by: 'assignment.worker.person.surname',
          second_order_workers_by: 'assignment.worker.person.first_name'
        }
      }).then(response => {
        this.data = response.data.data;
        this.prepareTimeSheetInformationX();
      });
    },
    prepareTimeSheetInformationX() {
      this.sortTimesheetAuthorisations();
      this.createWorkersList();
      this.createClientTimesheetWeek();
      this.createAdditionalSubmissionFields();
      this.setPays();
      this.loadingData = false;
    },
    sortTimesheetAuthorisations() {
      let self = this;
      // Sort the timesheet authorisations into alphabetical order of the selectted location name
      this.data = this.data.sort(function (a, b) {
        a.location.toLowerCase();
        b.location.toLowerCase();

        return (a < b) ? -1 : (a > b) ? 1 : 0;
      });
    },
    createClientTimesheetWeek() {
      // Find out the working week for this particular client
      let ts = this.data[0];

      // Only establish the working week for clients with timesheet records
      if (ts.ts_records.length > 0) {

        // Build up the week
        let exampleWeek = ts.ts_records[0].timesheet_pay;

        this.week = [];
        exampleWeek.forEach(day => {
          // Format the date for this client
          let week_format_day = this.$moment.utc(day.pay_date).format('ddd DD/MM/YYYY');
          this.week.push(week_format_day);
        });
      }
    },
    createAdditionalSubmissionFields() {
      // We need to build up additional fields and give them defaults to be used
      this.data.forEach(timesheetAuthorisation => {

        timesheetAuthorisation.showLocationInformation = false;
        timesheetAuthorisation.showReminderInformation = false;

        // Timesheets
        timesheetAuthorisation.ts_records.forEach(timesheetRecord => {

          // Week
          timesheetRecord.week = [];
          this.week.forEach(day => {
            timesheetRecord.week.push(0);
          });

          // Total Units
          timesheetRecord.totalUnits = 0;

          // Additions and deductions
          timesheetRecord.preTaxAdditions = [];
          timesheetRecord.postTaxAdditions = [];
          timesheetRecord.preTaxDeductions = [];
          timesheetRecord.postTaxDeductions = [];
        });

        // Orders
        timesheetAuthorisation.order_jobs.forEach(orderJob => {
          orderJob.showFields = false;

          orderJob.workLog = [];
          this.week.forEach(day => {
            orderJob.workLog.push({
              day: day,
              description: null
            });
          });

        });
      });
    },
    setPays() {
      this.data.forEach(timesheetAuthorisation => {
        timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
          this.taxAddDed(timesheetRecord);
          this.week.forEach((day, index) => {
            timesheetRecord.week[index] = timesheetRecord.timesheet_pay[index].price;
          });
        });
      });
    },
    taxAddDed(timesheetRecord) {
      // Additions and Deductions
      timesheetRecord.timesheet_additions_deductions.forEach(additionsAndDeductions => {

        // Build the addition/deduction object
        let savedAdditionsAndDeduction = {
          "id": additionsAndDeductions.id,
          "ts_record_id": additionsAndDeductions.ts_record_id,
          "amount": additionsAndDeductions.amount,
          "desc": additionsAndDeductions.desc
        };

        // Populate the addition/deduction into the right collection
        switch (this.workoutDeductionType(savedAdditionsAndDeduction)) {
          case 'preTaxAdditions':
            timesheetRecord.preTaxAdditions.push(savedAdditionsAndDeduction);
            break;
          case 'postTaxAdditions':
            timesheetRecord.postTaxAdditions.push(savedAdditionsAndDeduction);
            break;
          case 'preTaxDeductions':
            timesheetRecord.preTaxDeductions.push(savedAdditionsAndDeduction);
            break;
          case 'postTaxDeductions':
            timesheetRecord.postTaxDeductions.push(savedAdditionsAndDeduction);
            break;
        }

      });
    },
    workoutDeductionType(savedAdditionsAndDeduction) {
      // Check the ID against the various collections of CRM objects
      let id = savedAdditionsAndDeduction.desc.id;

      // Pre Tax Additions
      let matched = this.timesheetPreTaxAdditionsOptions.filter(object => {
        return object.id === id
      });
      if (matched.length > 0) {
        return 'preTaxAdditions';
      }

      // Post Tax Additions
      matched = this.timesheetPostTaxAdditionsOptions.filter(object => {
        return object.id === id
      });
      if (matched.length > 0) {
        return 'postTaxAdditions';
      }

      // Pre Tax Deductions
      matched = this.timesheetPreTaxDeductionsOptions.filter(object => {
        return object.id === id
      });
      if (matched.length > 0) {
        return 'preTaxDeductions';
      }

      // Post Tax Deductions
      matched = this.timesheetPostTaxDeductionsOptions.filter(object => {
        return object.id === id
      });
      if (matched.length > 0) {
        return 'postTaxDeductions';
      }

    },
    createWorkersList() {
      this.data.forEach(timesheetAuthorisation => {
        timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
          let worker = timesheetRecord.assignment.worker;

          // Filter the existing array down to see if we have already found this worker
          let matchedWorkers = this.workers.filter(workerReference => {
            return workerReference.id === worker.id
          });

          // Only add to our array if the worker does not already appear in it
          if (matchedWorkers.length <= 0) {
            this.workers.push(worker);
          }
        });
      });

      // Sort the workers by their full names alphabetically
      this.workers = this.workers.sort(function (a, b) {
        a = a.person.surname.toLowerCase() + ' ' + a.person.first_name.toLowerCase();
        b = b.person.surname.toLowerCase() + ' ' + b.person.first_name.toLowerCase();

        return (a < b) ? -1 : (a > b) ? 1 : 0;
      });

    },
    getWorkerPayRate(timesheetRecord) {
      if (this.isRecruitmentEnabled || timesheetRecord.assignment.order_job.order.order_type === 'Payroll - PAYE' || (
          this.isPayroll && timesheetRecord.assignment.order_job.order.order_type === 'Temporary (PAYE)'
      )) {
        return timesheetRecord.assignment.position_rate.admin_fee_amount;
      } else {
        return timesheetRecord.assignment.position_rate.pay_amount;
      }
    },
    getPreviewAllWorkerTimesheets(worker) {
      let timesheets = [];

      // Find anywhere that this worker has been submitted to see if we need to show their row
      this.data.forEach(timesheetAuthorisation => {
        timesheetAuthorisation.ts_records.forEach(timesheetRecord => {

          if (timesheetRecord.assignment.worker.id === worker.id) {
            timesheets.push(timesheetRecord);
          }

        });
      });

      return timesheets;
    },
    zIndexReverse(total, index) {
      let style = 'z-index: ' + ((10 + total) - index) + ';';

      if (total / (index + 1) === 2) {
        style += 'padding-right: 70px;';
      }

      return style;
    },
    isPreviewWorkerSubmitted(workerReference) {
      this.data.forEach(timesheetAuthorisation => {
        timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
          if (timesheetRecord.worker_submitted && timesheetRecord.worker_id === workerReference.id) {
            return true;
          }
        });
      });

      return false;
    },
    getPreviewWorkerFullName(worker) {
      return worker.person.first_name + ' ' + worker.person.surname;
    },
    getPreviewWorkerTotalBeforeAdditionsAndDeductions(worker, timesheetAuthorisation) {
      // Only get the timesheet that this worker is on
      let timesheetRecords = timesheetAuthorisation.ts_records.filter(timesheetRecord => {
        return timesheetRecord.assignment.worker.id === worker.id;
      });

      if (timesheetRecords.length === 0) {
        return 0;
      }

      // Select the first timesheet records
      let timesheetRecord = timesheetRecords[0];

      timesheetRecord.location = timesheetAuthorisation.location;

      return this.getTotalBeforeAdditionsAndDeductions(timesheetRecord);
    },
    getPreTaxAdditions(timesheetRecord) {
      return timesheetRecord.preTaxAdditions;
    },
    getPostTaxAdditions(timesheetRecord) {
      return timesheetRecord.postTaxAdditions;
    },
    getPreTaxDeductions(timesheetRecord) {
      return timesheetRecord.preTaxDeductions;
    },
    getPostTaxDeductions(timesheetRecord) {
      return timesheetRecord.postTaxDeductions;
    },
    getPreTaxAdditionsAmount(timesheetRecord) {
      let amount = 0;
      this.getPreTaxAdditions(timesheetRecord).forEach(submission => {
        amount += parseFloat(submission.amount);
      });
      return amount;
    },
    getPostTaxAdditionsAmount(timesheetRecord) {
      let amount = 0;
      this.getPostTaxAdditions(timesheetRecord).forEach(submission => {
        amount += parseFloat(submission.amount);
      });
      return amount;
    },
    getPreTaxDeductionsAmount(timesheetRecord) {
      let amount = 0;
      this.getPreTaxDeductions(timesheetRecord).forEach(submission => {
        amount += parseFloat(submission.amount);
      });
      return amount;
    },
    getPostTaxDeductionsAmount(timesheetRecord) {
      let amount = 0;
      this.getPostTaxDeductions(timesheetRecord).forEach(submission => {
        amount += parseFloat(submission.amount);
      });
      return amount;
    },
    getTotalBeforeAdditionsAndDeductions(timesheetRecord) {
      return this.getTotalUnits(timesheetRecord) * this.getWorkerPayRate(timesheetRecord);
    },
    getTotalUnits(timesheetRecord) {
      return timesheetRecord.total_hours;
    },
    getInvoiceTotal(timesheetRecord) {
      let invoiceAmount = 0;

      invoiceAmount += this.getTotalBeforeAdditionsAndDeductions(timesheetRecord);

      // Additions
      invoiceAmount += this.getPreTaxAdditionsAmount(timesheetRecord);
      invoiceAmount += this.getPostTaxAdditionsAmount(timesheetRecord);

      // Deductions
      invoiceAmount -= this.getPreTaxDeductionsAmount(timesheetRecord);
      invoiceAmount -= this.getPostTaxDeductionsAmount(timesheetRecord);

      return invoiceAmount;
    },
    getPreviewSumOfTotalBeforeAdditionsAndDeductions(timesheetAuthorisation) {
      return this.sumOfTotalBeforeAdditionsAndDeductions(timesheetAuthorisation);
    },
    sumOfTotalBeforeAdditionsAndDeductions(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getTotalBeforeAdditionsAndDeductions(timesheetRecord);
      });

      return total;
    },
    sumOfPreTaxAdditionsAmount(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getPreTaxAdditionsAmount(timesheetRecord);
      });

      return total;
    },
    sumOfPostTaxAdditionsAmount(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getPostTaxAdditionsAmount(timesheetRecord);
      });

      return total;
    },
    sumOfPreTaxDeductionsAmount(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getPreTaxDeductionsAmount(timesheetRecord);
      });

      return total;
    },
    sumOfPostTaxDeductionsAmount(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getPostTaxDeductionsAmount(timesheetRecord);
      });

      return total;
    },
    sumOfInvoiceTotal(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getInvoiceTotal(timesheetRecord);
      });

      return total;
    },
    explainWorkerPreTaxAddition(worker) {
      let reasons = [];

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      let value;
      timesheets.forEach(timesheet => {
        value = this.getPreTaxAdditionsAmount(timesheet);
        if (value > 0) {
          reasons.push({
            location: timesheet.location,
            order_job_id: timesheet.order_job_id,
            assignment_id: timesheet.assignment_id,
            amount: value
          });
        }
      });

      return reasons;
    },
    getPreviewWorkerPreTaxAddition(worker) {
      let total = 0;

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      timesheets.forEach(timesheet => {
        total += this.getPreTaxAdditionsAmount(timesheet);
      });

      return total;
    },
    explainWorkerPostTaxAddition(worker) {
      let reasons = [];

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      let value;
      timesheets.forEach(timesheet => {
        value = this.getPostTaxAdditionsAmount(timesheet);
        if (value > 0) {
          reasons.push({
            location: timesheet.location,
            order_job_id: timesheet.order_job_id,
            assignment_id: timesheet.assignment_id,
            amount: value
          });
        }
      });

      return reasons;
    },
    getPreviewWorkerPostTaxAddition(worker) {
      let total = 0;

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      timesheets.forEach(timesheet => {
        let value = this.getPostTaxAdditionsAmount(timesheet);

        total += value;
      });

      return total;
    },
    explainWorkerPreTaxDeduction(worker) {
      let reasons = [];

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      let value;
      timesheets.forEach(timesheet => {
        value = this.getPreTaxDeductionsAmount(timesheet);
        if (value > 0) {
          reasons.push({
            location: timesheet.location,
            order_job_id: timesheet.order_job_id,
            assignment_id: timesheet.assignment_id,
            amount: value
          });
        }
      });

      return reasons;
    },
    getPreviewWorkerPreTaxDeduction(worker) {
      let total = 0;

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      timesheets.forEach(timesheet => {
        total += this.getPreTaxDeductionsAmount(timesheet);
      });

      return total;
    },
    explainWorkerPostTaxDeduction(worker) {
      let reasons = [];

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      let value;
      timesheets.forEach(timesheet => {
        value = this.getPostTaxDeductionsAmount(timesheet);
        if (value > 0) {
          reasons.push({
            location: timesheet.location,
            order_job_id: timesheet.order_job_id,
            assignment_id: timesheet.assignment_id,
            amount: value
          });
        }
      });

      return reasons;
    },
    getPreviewWorkerPostTaxDeduction(worker) {
      let total = 0;

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      timesheets.forEach(timesheet => {
        total += this.getPostTaxDeductionsAmount(timesheet);
      });

      return total;
    },
    getPreviewWorkerInvoiceTotal(worker) {
      let total = 0;

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      timesheets.forEach(timesheetRecord => {

        total += this.getInvoiceTotal(timesheetRecord);

      });

      return total;
    },
    getPreviewSumOfPreTaxAddition() {
      let total = 0;
      this.data.forEach(timesheetAuthorisation => {
        total += this.sumOfPreTaxAdditionsAmount(timesheetAuthorisation);
      });
      return total;
    },
    getPreviewSumOfPostTaxAddition() {
      let total = 0;
      this.data.forEach(timesheetAuthorisation => {
        total += this.sumOfPostTaxAdditionsAmount(timesheetAuthorisation);
      });
      return total;
    },
    getPreviewSumOfPreTaxDeduction() {
      let total = 0;
      this.data.forEach(timesheetAuthorisation => {
        total += this.sumOfPreTaxDeductionsAmount(timesheetAuthorisation);
      });
      return total;
    },
    getPreviewSumOfPostTaxDeduction() {
      let total = 0;
      this.data.forEach(timesheetAuthorisation => {
        total += this.sumOfPostTaxDeductionsAmount(timesheetAuthorisation);
      });
      return total;
    },
    getPreviewSumOfInvoiceTotal() {
      let total = 0;
      this.data.forEach(timesheetAuthorisation => {
        total += this.sumOfInvoiceTotal(timesheetAuthorisation);
      });
      return total;
    },
    getComponent(componentName) {
      let component = null
      let parent = this.$parent
      while (parent && !component) {
        if (parent.$options.name === componentName) {
          component = parent
        }
        parent = parent.$parent
      }
      return component
    }
  },
};
</script>
